module.exports = __webpack_public_path__ + "img/journey.e7a3e05c.png";